import { api } from './api';

export const startCheckout = async ({ billingCycle = 'monthly' } = {}) => {
  const { url } = await api.createCheckoutSession(billingCycle);
  window.location.href = url;
};

export const openBillingPortal = async () => {
  const { url } = await api.createPortalSession();
  window.location.href = url;
};
